<template>
    <v-container class="pl-0">
        <entity-nav :navItems="navItems" useEvents></entity-nav>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </v-container>
</template>
<script lang="js">
import EntityNav from '../../components/EntityNav.vue'
import { mapState } from 'vuex'
const entity = 'eventslot'
import permissionsSet from '../../components/permissions'
export default {
    name: 'TimetableHome',
    components: {
        'entity-nav': EntityNav,
    },
    computed: {
        ...mapState(['user']),
        navItems() {
            let items = [
                { title: 'Timetable', icon: 'mdi-timetable', to: 'eventtimetable' },
                { title: 'List', icon: 'mdi-view-list', to: 'eventtimetablelist' },
            ]
            if (this.canCreate) items = [{ title: 'New', icon: 'mdi-plus', to: 'newEncounter' }, ...items]

            return items
        },
        canCreate() {
            console.log(this.user)
            if (this.user && this.user[entity]) {
                return this.user[entity].owned.includes(permissionsSet.Create)
            } else {
                return false
            }
        },
    },
}
</script>
